import Cookies from 'js-cookie';

const expiredAt = new Date('Fri, 31 Dec 9999 23:59:59 GMT');
const rootDomain = process.env.VUE_APP_COOKIE_HOST;
const VUE_APP_IS_DDE = process.env.VUE_APP_IS_DDE == 'true';

const languageMappping = {
  'zh': 'zh-CN',
  'en': 'en-US'
}

export function setLanguage(lang: string) {
  Cookies.set(
    'locale', 
    languageMappping[lang], 
    { 
      expires: expiredAt, 
      domain: rootDomain
    }
  );
}

export function getLanguage() {
  const locale = Cookies.get('locale');
  if (VUE_APP_IS_DDE) {
    return locale == 'zh' ? 'zh' : 'en';
  }
  return locale == 'en-US' ? 'en' : 'zh';
}

export function getMomentLanguage(locale: string) {
  if (VUE_APP_IS_DDE) {
    return locale == 'zh' ? 'zh' : 'en';
  }
  return  locale == 'en' ? 'en' : 'zh-cn';
}